export default __webpack_public_path__ + "static/media/jupiter.3fa282ba.png";